import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { setBreadcrumbs, setBreadcrumbsCurrentElement } from 'store/breadcrumbsSlice';
import { ElementType, ElementViewerCrumbsData, ElementViewerCrumbsDataItem } from 'components/element-viewer/index';
import { setPageTitle } from 'store/pageTitleSlice';
import { useLocation } from 'react-router-dom';
import { catalogItem } from 'store/auth';
import { useCatalogDataById } from 'hooks/useCatalog';

export default function usePageTitleCrumbs(elementInfo: ElementType, crumbsData: ElementViewerCrumbsData) {
    const location = useLocation();
    const dispatch = useDispatch();
    const catalogItems: catalogItem[] = useSelector((state: any) => state.auth?.userInfo?.catalogItems) ?? [];
    const defaultCatalog = useCatalogDataById(elementInfo?.row?.defaultCatalogId ?? 0);

    useEffect(() => {
        let match = location.pathname.match(/\/(favorite|folder)\/([0-9]+)/);

        let currentCatalog: catalogItem | undefined;
        let catalogMatch = location.pathname.match(/\/(catalog)\/([0-9]+)/);
        if (catalogMatch) {
            currentCatalog = catalogItems.find((catalog) => catalog.catalog_id === Number(catalogMatch[2]));
        }

        const referrerType = match && match[1] && match[2] ? match[1] : undefined;

        let crumbsType: any = undefined;

        switch (referrerType) {
            case 'favorite':
                if (crumbsData?.favorite?.length > 0) {
                    crumbsType = 'favorite';
                }
                break;
            case 'folder':
                if (crumbsData?.folderCurrent?.length > 0) {
                    crumbsType = 'folderCurrent';
                }
                break;
        }

        if (!crumbsType) {
            if (crumbsData?.folderDefault?.length > 0) {
                crumbsType = 'folderDefault';
            } else {
                crumbsType = 'category';
            }
        }

        let crumbsResult = (currentCatalog ? [currentCatalog] : []).map((catalog: catalogItem) => {
            return {
                href: catalog.is_system_ind == 'Y' ? '/home' : '/catalog/' + catalog.url_name,
                label: catalog.name,
            };
        });

        if (!currentCatalog && defaultCatalog) {
            crumbsResult.push({
                href: defaultCatalog.is_system_ind == 'Y' ? '/home' : '/catalog/' + defaultCatalog.url_name,
                label: defaultCatalog.name,
            });
        }
        crumbsResult = [...crumbsResult, ...((crumbsData as any)?.[crumbsType] ?? [])];

        dispatch(
            setBreadcrumbs(
                crumbsResult.map((crumbsItem: ElementViewerCrumbsDataItem) => ({
                    ...crumbsItem,
                    translate: false,
                })),
            ),
        );
        dispatch(setBreadcrumbsCurrentElement(elementInfo?.row.name)); //workaround for recent items command menu
        dispatch(setPageTitle(elementInfo?.row.name));

        return () => {
            dispatch(setBreadcrumbsCurrentElement(null));
        };
    }, [elementInfo.row?.elementId, elementInfo.row?.segmentValueId]);
}
